import React, { useEffect } from 'react';
import { StyleSheet, View, Text, Animated } from 'react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { useAppColors } from '../../hooks/useAppColors';
import { useAuthStore } from '../../stores/authStore';
import { useTranslation } from 'react-i18next';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export default function ActivationSuccessBanner() {
  const { t } = useTranslation();
  const colors = useAppColors();
  const insets = useSafeAreaInsets();
  const showBanner = useAuthStore((s) => s.showActivationSuccessBanner);
  const setShowBanner = useAuthStore((s) => s.setShowActivationSuccessBanner);
  
  const translateY = new Animated.Value(-100);

  useEffect(() => {
    if (showBanner) {
      Animated.timing(translateY, {
        toValue: 0,
        duration: 300,
        useNativeDriver: true,
      }).start();

      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        Animated.timing(translateY, {
          toValue: -100,
          duration: 300,
          useNativeDriver: true,
        }).start(() => {
          setShowBanner(false);
        });
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [showBanner, setShowBanner, translateY]);

  if (!showBanner) return null;

  return (
    <Animated.View
      style={[
        styles.banner,
        {
          backgroundColor: colors.success,
          transform: [{ translateY }],
          // Absolute overlay at the top of the screen: keep content clear of
          // the OS status bar / notch on both platforms
          paddingTop: 12 + insets.top,
        },
      ]}
    >
      <Icon name="check-circle" size={20} color="#fff" />
      <Text style={styles.bannerText}>{t('activationSuccess.title')}</Text>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  banner: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
  },
  bannerText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
  },
});
